// extracted by mini-css-extract-plugin
module.exports = {"assets":"Layout4_assets__192uT","block":"Layout4_block__k-JUK","rowDiv":"Layout4_rowDiv__2HLWf"};